<template>
  <div class="page" v-if="total>0">
    <el-pagination :current-page.sync="currentPage" :page-size="limit" :total="total" @current-change="handleCurrentChange" background layout="total,  prev, pager, next, jumper">
    </el-pagination>
  </div>
</template>

<script>
  export default {
    name: "Pagination",
    props: {
      total: {
        required: false,
        default: 0,
      },
      limit: {
        required: false,
        default: 10,
      },
      small: {
        required: false,
        type: Boolean,
        default: false,
      },
    },
    // watch: {
    //   currentPage(val) {
    //     if (typeof val === "number") {
    //       console.log(this.currentPage);
    //       this.currentPage = val;
    //     }
    //   },
    // },
    data() {
      return {
        currentPage: 1,
      };
    },
    created() {
    },
    methods: {
      handleCurrentChange(val) {
        /**
         * 子传父
         * 参数1 父元素方法
         * 参数2 数据
         */
        this.$emit("handleCurrentChange", val);
      },
    },
  };
</script>

<style lang="less" scoped>
  .page {
    height: 40px;
    margin: auto;
    text-align: center;
    color: #333333;
    background-color: #fff;
  }

  .el-pagination {
    color: #fff;
  }

  /deep/ .el-pagination.is-background .el-pager li {
    border-radius: 25px;
    background-color: #ebf2f8;
  }

  /deep/ .el-pagination.is-background .btn-prev {
    background: none;
  }

  /deep/ .el-pagination.is-background .btn-next {
    background: none;
  }

  /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #c09351;
  }
</style>
